// extracted by mini-css-extract-plugin
export var banner = "styles-module--banner--91de3";
export var description = "styles-module--description--baf38";